import {
  ACCENT_COLOR_TYPE_BY_BONUS,
  BONUSES_TYPES_FOR_IMAGES,
  jackpotWinsStates
} from '../../../constants';
import prepareBonusDetailsList from '../../../utils/prepareBonusDetailsList';

const getBonusDetailsList = ({ bonusData, f, t, providerName, gameName }) => {
  const { userRealAmount, userCurrency, createdAt, status, expiredAt } =
    bonusData;
  const DATE_FORMATS_TYPES = f.getFormats();

  return prepareBonusDetailsList([
    {
      name: t('bonuses.details.jackpot.amount'),
      value: `${userRealAmount} ${userCurrency}`,
      isDisplay: true,
      isBonusAmount: true
    },
    {
      name: t('bonuses.details.jackpot.received'),
      value: f
        .getDateTime({
          date: createdAt
        })
        ?.toFormat(DATE_FORMATS_TYPES.IN_HOUSE_JACKPOT_DATE_FORMAT),
      isDisplay: status === jackpotWinsStates.ACCEPTED
    },
    {
      name: t('bonuses.details.jackpot.expiryDate'),
      value: f
        .getDateTime({
          date: expiredAt
        })
        ?.toFormat(DATE_FORMATS_TYPES.IN_HOUSE_JACKPOT_DATE_FORMAT),
      isDisplay: status === jackpotWinsStates.EXPIRED
    },
    {
      name: t('bonuses.details.jackpot.provider'),
      value: providerName,
      isDisplay: providerName
    },
    {
      name: t('bonuses.details.jackpot.game'),
      value: gameName,
      isDisplay: gameName
    }
  ]);
};

export const normalizeJackpotWinBonusDetails = ({
  bonusData,
  f,
  t,
  gameName,
  providerName
}) => {
  const { id: bonusId, status, expiredAt } = bonusData;

  const isActive = status === jackpotWinsStates.AVAILABLE;

  return {
    ...bonusData,
    bonusId,
    isShowButton: isActive,
    isCountdownTimerEnabled: isActive,
    expireTime: {
      sec: f
        .getDateTime({
          date: expiredAt
        })
        .toSeconds(),
      ms: f
        .getDateTime({
          date: expiredAt
        })
        .toMillis()
    },
    bonusDetailsList: getBonusDetailsList({
      bonusData,
      f,
      t,
      gameName,
      providerName
    }),
    imageColorAccent:
      ACCENT_COLOR_TYPE_BY_BONUS[BONUSES_TYPES_FOR_IMAGES.JACKPOT_BONUS],
    isJackpotBonus: true
  };
};
